


import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkLogin } from "../Helper/links";
import API from "../Helper/server/API";
import logoimg from "../public/images/logo.png";
import './login.css';
import ReCAPTCHA from "react-google-recaptcha";
const RECAPTCHA_SITE_KEY = "6LdzdEYsAAAAABxI393VtK9hU-tQO99yU_0bcms_";
// <-- replace with your reCAPTCHA v2 site key
function Login() {
  //localStorage.clear();
  const toast = useRef(null);
  const navigate = useNavigate();
  const [loading_login, set_loading_login] = useState(false)
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const userlogin = async (e) => {
    e.preventDefault();
    set_loading_login(true);
    //  if (!captchaToken) {
    //   toast.current.show({
    //       style:{
    //           fontFamily:"Cairo",
    //           fontSize:"1.2rem"
    //       },
    //       life: 5000,
    //       severity:'error', summary: 'خطــاء', detail:"يرجى تأكيد أنك لست روبوتًا"
    //   });
    //   set_loading_login(false);
    //   return;
    //  }
    if (!username && username === "" && !password && password === "") {
      set_loading_login(false);
      toast.current.show({
        style: {
          fontFamily: "Cairo",
          fontSize: "1.2rem"
        },
        life: 5000,
        severity: 'error', summary: 'خطــاء', detail: "ارجو ادخال اسم المستخدم و كلمة المرور  "
      });
      //errorhandler()
    }
    else if (username.match((/^[a-zA-Z]+$/)) === false) {
      set_loading_login(false);
      toast.current.show({
        style: {
          fontFamily: "Cairo",
          fontSize: "1.2rem"
        },
        life: 5000,
        severity: 'error', summary: 'خطــاء', detail: " ارجو ادخال اسم المستخدم بطريقة صحيحة"
      });
    }
    else {
      const response = await API.post(linkLogin, {
        username: username,
        password: password,
        captchaToken: captchaToken
      })
      set_loading_login(false);
      if (response?.success === 1) {
        window.localStorage.setItem("isLogIn", true);
        window.localStorage.setItem("username", response.user.username);
        window.localStorage.setItem("name", response.user.name);
        window.localStorage.setItem("phone", response.user.phone);
        window.localStorage.setItem("type", response.user.type);
        window.localStorage.setItem("token", response.user.token);
        //_____________________________________________________________________
        window.localStorage.setItem("resort_name_en", response.user.name_en);
        window.localStorage.setItem("resort_name_ar", response.user.name_ar);
        window.localStorage.setItem("short_resort_name", response.user.short_name);
        window.localStorage.setItem("resort_phone_1", response.user.phone_1);
        window.localStorage.setItem("resort_phone_2", response.user.phone_2);
        window.localStorage.setItem("resort_email", response.user.email);
        window.localStorage.setItem("resort_website", response.user.website);
        window.localStorage.setItem("resort_logo_path", response.user.logo_path);
        const redirectPath = (window.location.pathname === "/login" || window.location.pathname === "/logout")
          ? "/"
          : (window.location.pathname + window.location.search);
        window.location.href = redirectPath;
      }
      if (response?.success === 500 || response?.error === 1) {
        toast.current.show({
          style: {
            fontFamily: "Cairo",
            fontSize: "1.2rem"
          },
          life: 5000,
          severity: 'error', summary: 'نجــاح', detail: response?.msg
        });
      }
      else if (response?.success === 0) {
        toast.current.show({
          style: {
            fontFamily: "Cairo",
            fontSize: "1.2rem"
          },
          life: 5000,
          severity: 'error', summary: 'خطــاء', detail: response?.msg
        });
      }
    }
  };

  return (
    <>

      <div className="full_container bgbgb" dir="rtl" style={{ backgroundColor: "rgb(21, 40, 60)" }}>
        <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
        <div className="container" style={{ paddingTop: "100px" }}>
          <div className="center verticle_center full_height ">
            <div className="login_section" style={{ width: "600px", maxHeight: "600px" }}>
              <center>
                <div className="logo_login" style={{
                  background: `url(${logoimg})`,
                  width: "250px",
                  height: "250px",
                  // padding: "120px 100px",
                  backgroundPosition: "center",
                  position: "relative",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "250px ",
                }} >
                </div>
              </center>
              <hr></hr>
              <div className="login_form" >
                <form>
                  <fieldset>
                    <div className="field" >
                      <label className="label_field" style={{ float: "right" }}>
                        اسم المستخدم
                      </label>
                      <input
                        id="user"
                        type="text"
                        name="username"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>

                    <div className="field" style={{ paddingTop: "50px" }}>
                      <label className="label_field" style={{ float: "right" }}>كلمة المرور</label>
                      <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="field" style={{ paddingTop: "50px" }}>
                      <center>
                        {/* <ReCAPTCHA
                                  sitekey={RECAPTCHA_SITE_KEY}
                                  onChange={(token) => setCaptchaToken(token)}
                                   hl="ar"
                                /> */}
                      </center>
                    </div>

                  </fieldset>
                  <center >

                    <div className="col-md-12">
                      <Button dir="ltr" label=" تسجيل دخول " raised loading={loading_login} style={{ fontFamily: "Cairo", backgroundColor: "rgb(20, 176, 204)" }} onClick={e => userlogin(e)} />
                    </div>
                  </center>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>

  );
}
export default Login;